(() => {
'use strict';
const CONFIG = {"projectId":"598975","apiHost":"https://us.posthog.com","ingestionHost":"https://us.i.posthog.com","projectToken":"phc_oc2hhzqp28N5didH2yF8bZEV6EFQw94kFZvFeDdFsubU","store":"lazy-turtle-shop","schemaVersion":"lt-cro-1","conversionWindowHours":24,"experiment":null};
const SCHEMA = 'lt-cro-1';
const money = v => v !== null && v !== undefined && Number.isFinite(Number(v)) ? Number(v) : null;
function product(v = {}) {
  return {product_id: v.product?.id ?? null, product_name: v.product?.title ?? null,
    product_type: v.product?.type ?? null, variant_id: v.id ?? null, variant_name: v.title ?? null,
    unit_price: money(v.price?.amount), currency: v.price?.currencyCode ?? null};
}
function items(lines = []) {
  return lines.map(l => ({...product(l.variant || l.merchandise || {}),
    product_name: l.variant?.product?.title || l.merchandise?.product?.title || l.title || null,
    quantity: money(l.quantity), line_total: money(l.finalLinePrice?.amount ?? l.cost?.totalAmount?.amount)}));
}
function checkout(c = {}) {
  const products = items(c.lineItems);
  const codes = Array.isArray(c.discountApplications) ? c.discountApplications.filter(d => d.type === 'DISCOUNT_CODE').map(d => d.title) : null;
  const first = c.order?.customer?.isFirstOrder;
  return {checkout_id: c.token || null, order_id: c.order?.id || null,
    cart_value: money(c.totalPrice?.amount), revenue: money(c.totalPrice?.amount),
    subtotal: money(c.subtotalPrice?.amount), shipping: money(c.shippingLine?.price?.amount),
    tax: money(c.totalTax?.amount), currency: c.currencyCode || c.totalPrice?.currencyCode || null,
    item_count: products.length ? products.reduce((n,p) => n + (p.quantity || 0), 0) : null,
    line_count: c.lineItems ? c.lineItems.length : null, products,
    discount_codes: codes, discount_code_present: codes === null ? null : codes.length > 0,
    purchaser_status: typeof first === 'boolean' ? (first ? 'new' : 'returning') : 'unknown',
    purchaser_status_source: typeof first === 'boolean' ? 'shopify_order_isFirstOrder' : 'unavailable'};
}
function ajaxCart(c) {
  return {cart_id: String(c.token || '').split('?')[0] || null, cart_value: money(c.total_price) === null ? null : c.total_price / 100,
    currency: c.currency || null, item_count: money(c.item_count), line_count: c.items?.length ?? null,
    products: (c.items || []).map(l => ({product_id: String(l.product_id), variant_id: String(l.variant_id),
      product_name: l.product_title || l.title, variant_name: l.variant_title,
      unit_price: money(l.final_price) === null ? null : l.final_price / 100,
      line_total: money(l.final_line_price) === null ? null : l.final_line_price / 100, quantity:l.quantity})),
    snapshot_at: new Date().toISOString(), snapshot_source: 'shopify_ajax_cart'};
}
function cleanUrl(value) {
  try { const u = new URL(value); return u.origin + u.pathname.replace(/\/checkouts\/[^/]+\/[^/]+/g, '/checkouts/[redacted]').replace(/\/orders\/[^/]+/g, '/orders/[redacted]'); } catch { return null; }
}
function attribution(url, referrer, origin) {
  const u = new URL(url); const out = {};
  for (const k of ['source','medium','campaign','term','content']) {
    const value = u.searchParams.get('utm_' + k);
    out['utm_' + k] = value && !/[@\r\n]/.test(value) ? value.slice(0,160) : null;
  }
  let ref = null; try { ref = new URL(referrer).hostname; } catch {}
  out.referrer_host = ref;
  out.acquisition_source = out.utm_source || (ref && ref !== origin ? ref : 'direct');
  return out;
}

// Bundled into both integrations. STORAGE is Shopify's first-party browser API in the pixel.
const KEY = 'lt_cro_context_v1';
let localContext = null;
const uuid = () => crypto.randomUUID();
async function readJson(key) { try { return JSON.parse(await STORAGE.getItem(key)); } catch { return null; } }
async function writeJson(key, value) { try { await STORAGE.setItem(key, JSON.stringify(value)); return true; } catch { return false; } }
async function context(url, referrer, userAgent, customerId) {
  const now = Date.now();
  let s = await readJson(KEY) || localContext;
  const wasMissing = !s;
  if (!s) s = {anonymous_id: uuid(), first_touch: attribution(url, referrer, new URL(url).hostname)};
  if (!s.session_id || now - s.last_seen > 30 * 60 * 1000) {
    s.session_id = uuid(); s.session_touch = attribution(url, referrer, new URL(url).hostname);
    s.experiment_id = null; s.experiment_variant = null;
  }
  if (customerId) s.customer_id = 'shopify:' + CONFIG.store + ':' + String(customerId).split('/').pop();
  // Theme supplies an explicit logged-out state; pixel init can be absent in checkout.
  if (customerId === false && s.customer_id) { s.customer_id = null; s.anonymous_id = uuid(); s.session_id = uuid(); }
  s.is_test = s.is_test === true || new URL(url).searchParams.get('cro_test') === '1';
  s.last_seen = now;
  s.device_type = /ipad|tablet/i.test(userAgent) ? 'tablet' : /mobile|iphone|android/i.test(userAgent) ? 'mobile' : 'desktop';
  s.storage_available = await writeJson(KEY,s);
  localContext = s;
  return {...s, context_created_here:wasMissing};
}
function common(s, url) {
  return {schema_version:CONFIG.schemaVersion, is_test:s.is_test === true, integration:'lazy-turtle-cro',
    anonymous_id:s.anonymous_id, cro_session_id:s.session_id,
    device_type:s.device_type, storage_available:s.storage_available,
    identity_status:s.customer_id ? 'identified' : 'anonymous',
    $current_url:cleanUrl(url), page_path:cleanUrl(url)?.replace(/^https?:\/\/[^/]+/,'') || null,
    ...s.session_touch,
    ...Object.fromEntries(Object.entries(s.first_touch || {}).map(([k,v]) => ['first_'+k,v])),
    experiment_id:s.experiment_id || null, experiment_variant:s.experiment_variant || null};
}
function loadSDK(options) {
  return new Promise((resolve,reject) => {
    // Official array.js distribution; explicit init after script load avoids an unbounded stub queue.
    const script = document.createElement('script');
    script.async = true; script.crossOrigin = 'anonymous';
    script.src = CONFIG.ingestionHost.replace('.i.posthog.com','-assets.i.posthog.com') + '/static/array.js';
    script.onerror = () => reject(new Error('PostHog SDK could not load'));
    script.onload = () => {
      window.posthog.init(CONFIG.projectToken, {
        api_host:CONFIG.ingestionHost, defaults:'2026-05-30', persistence:'memory',
        capture_pageview:false, capture_pageleave:false, autocapture:false,
        disable_session_recording:true, capture_dead_clicks:false, rageclick:false,
        person_profiles:'identified_only', advanced_disable_feature_flags:true,
        mask_all_text:true, mask_all_element_attributes:true,
        save_referrer:false, save_campaign_params:false,
        ...options, loaded: sdk => resolve(sdk)
      });
    };
    document.head.appendChild(script);
  });
}
function stripAutomatic(event) {
  // Do not leak SDK auto-properties containing URLs, form text, IP, or customer PII.
  if (!event) return null;
  const safe = new Set(['$current_url','$insert_id','$anon_distinct_id','$set','$set_once','$is_identified']);
  for (const k of Object.keys(event.properties || {})) {
    if (k.startsWith('$') && !safe.has(k)) delete event.properties[k];
  }
  if (event.properties.$set) event.properties.$set = {};
  if (event.properties.$set_once) event.properties.$set_once = {};
  event.properties.$geoip_disable = true;
  return event;
}

const STORAGE = window.localStorage;
const META = window.LazyTurtleCROConfig || {};
let sdk, started = false, refreshing = false, cartTimer, current = null;
const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
async function refresh() {
  if (!allowed()) return;
  current = await context(location.href,document.referrer,navigator.userAgent,META.customerId || false);
  if (sdk) {
    if (current.customer_id && sdk.get_distinct_id() !== current.customer_id) sdk.identify(current.customer_id);
    sdk.register(common(current,location.href));
  }
}
async function snapshot() {
  if (!allowed()) return;
  const res = await originalFetch((window.Shopify.routes?.root || '/') + 'cart.js', {credentials:'same-origin',cache:'no-store'});
  if (!res.ok) return;
  const cart = ajaxCart(await res.json());
  if (!allowed()) return;
  const previous = await readJson('lt_cro_cart_v1');
  await writeJson('lt_cro_cart_v1',cart);
  const signature = x => JSON.stringify([x?.cart_id,x?.cart_value,x?.currency,x?.products]);
  if (signature(previous) !== signature(cart) || !previous || Date.now()-Date.parse(previous.snapshot_at)>30*60000) {
    window.Shopify.analytics.publish('lt_cro_cart_snapshot',cart);
  }
}
const originalFetch = window.fetch.bind(window);
function scheduleCart() { clearTimeout(cartTimer); cartTimer=setTimeout(() => snapshot().catch(() => {}),100); }
async function start() {
  if (!allowed() || refreshing) return;
  refreshing=true;
  try {
    await refresh();
    if (META.product) await writeJson('lt_cro_product_v1', META.product);
    if (started) { sdk?.opt_in_capturing({captureEventName:false}); return; }
    sdk = await loadSDK({bootstrap:{distinctID:current.anonymous_id,isIdentifiedID:false},
      autocapture:true,rageclick:true,capture_dead_clicks:true,
      before_send:e => {
        if (!allowed()) return null;
        const fresh = (()=>{try{return JSON.parse(localStorage.getItem(KEY));}catch{return null;}})();
        if (fresh) Object.assign(e.properties,common(fresh,location.href));
        e.properties.event_source='storefront_theme';
        return stripAutomatic(e);
      }});
    started=true;
    await refresh();
    sdk.capture('cro_storefront_ready',{friction_enabled:true});
    // Observe successful AJAX cart mutations without reading customer form bodies.
    window.fetch = function(...args) {
      const result=originalFetch(...args);
      const url=String(args[0]?.url || args[0]);
      if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) result.then(r=>{if(r.ok)scheduleCart();},()=>{});
      return result;
    };
    const open=XMLHttpRequest.prototype.open, send=XMLHttpRequest.prototype.send;
    const mutation = new WeakSet();
    XMLHttpRequest.prototype.open=function(method,url,...rest) {
      if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(String(url))) mutation.add(this); else mutation.delete(this);
      return open.call(this,method,url,...rest);
    };
    XMLHttpRequest.prototype.send=function(...args) {
      if (mutation.has(this)) this.addEventListener('load',()=>{if(this.status>=200&&this.status<300)scheduleCart();},{once:true});
      return send.apply(this,args);
    };
    document.addEventListener('click',()=>{refresh().catch(()=>{});},true);
    document.addEventListener('cart:updated',scheduleCart);
    window.addEventListener('pageshow',scheduleCart);
    await snapshot();
    window.LazyTurtleCRO = {
      // Call ONLY after the visitor actually sees the rendered variant.
      async exposed(experimentId,variant) {
        if (!allowed()) return;
        if (!/^[a-zA-Z0-9_-]{1,80}$/.test(experimentId) || !/^[a-zA-Z0-9_-]{1,40}$/.test(variant)) throw new Error('Invalid experiment name or variant');
        await refresh(); current.experiment_id=experimentId; current.experiment_variant=variant;
        await writeJson(KEY,current); sdk.register(common(current,location.href));
        sdk.capture('experiment_exposed',{experiment_id:experimentId,experiment_variant:variant,$insert_id:'lt:exp:'+current.session_id+':'+experimentId+':'+variant});
      },
      async assign(experimentId) {
        if (!allowed()) return null;
        const key='lt_cro_experiment_'+experimentId;
        let variant=await STORAGE.getItem(key);
        if (!['A','B'].includes(variant)) {
          variant=(crypto.getRandomValues(new Uint32Array(1))[0]%2) ? 'A' : 'B';
          await STORAGE.setItem(key,variant);
        }
        return variant;
      },
      snapshot
    };
  } catch { console.warn('[Lazy Turtle CRO] Storefront setup failed; inspect integration.'); }
  finally {refreshing=false;}
}
document.addEventListener('visitorConsentCollected',()=>{
  if (allowed()) start(); else {
    sdk?.opt_out_capturing(); current=null;
    for (const key of [KEY,'lt_cro_cart_v1','lt_cro_product_v1']) STORAGE.removeItem(key);
  }
});
if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)start();});
else console.warn('[Lazy Turtle CRO] Shopify consent API unavailable; tracking remains off.');

})();